import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'prcins-mobile-app-redirect',
  templateUrl: './mobile-app-redirect.component.html',
  styleUrls: ['./mobile-app-redirect.component.css']
})
export class MobileAppRedirectComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
